<template>
  <div class="product-plan">
    <header class="product-plan-header">
      <div class="logo-container">
        <img
          src="~@/assets/img/photos/product_logo.png"
          alt="商標"
          class="logo"
        />
      </div>
      <div class="header-image-container">
        <img
          src="~@/assets/img/photos/BN_1920X960.png"
          alt="圖片"
          class="header-image"
        />
      </div>
    </header>
    <h1 class="title">方案列表</h1>
    <div class="filter">
      <label for="category-select">方案篩選</label>
      <select
        id="category-select"
        v-model="selectedCategory"
        @change="filterProducts"
      >
        <option value="">全方案</option>
        <option
          v-for="category in categories"
          :key="category.id"
          :value="category.id"
        >
          {{ category.name }}
        </option>
      </select>
    </div>
    <div class="category-list">
      <div
        v-for="category in categories"
        :key="category.id"
        class="category-section"
      >
        <h2 class="category-title">{{ category.name }}</h2>
        <div class="product-list">
          <div
            class="product-item"
            v-for="product in filteredProductsByCategory(category.id)"
            :key="product.program_id"
          >
            <img
              :src="product.photo"
              :alt="`方案圖片 ${product.program_id}`"
              class="product-image"
            />
            <p class="product-price">{{ product.price }} 元</p>
            <button class="buy-button" @click="buyProduct(product.program_id)">
              立即購買
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchProductPlans } from '@/api/product_plan';

export default {
  data() {
    return {
      categories: [],
      products: [],
      selectedCategory: '' // 選擇的類別
    };
  },
  computed: {
    filteredProductsByCategory() {
      return categoryId =>
        this.products.filter(product =>
          this.selectedCategory
            ? product.purchase_site_category_id === categoryId &&
              product.purchase_site_category_id ===
                parseInt(this.selectedCategory)
            : product.purchase_site_category_id === categoryId
        );
    }
  },
  methods: {
    async fetchProductPlans() {
      try {
        const response = await new Promise((resolve, reject) => {
          fetchProductPlans(
            data => resolve(data),
            error => reject(error)
          );
        });

        if (response) {
          this.products = response;
          this.categories = response.reduce((acc, item) => {
            if (
              !acc.find(
                category => category.id === item.purchase_site_category_id
              )
            ) {
              acc.push({
                id: item.purchase_site_category_id,
                name: item.purchase_site_category_name
              });
            }
            return acc;
          }, []);
        }
      } catch (error) {
        console.error('Failed to fetch product plans:', error);
      }
    },
    filterProducts() {
      // 不需要額外邏輯，依靠 computed 動態篩選
    },
    buyProduct(programId) {
      // 購買邏輯，跳轉到付款頁面
      this.$router.push({
        name: 'Checkout',
        params: { program_id: programId }
      });
    }
  },
  mounted() {
    this.fetchProductPlans();
    document.title = '昱驊養生瑜珈中心-線上購課';
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/page/ProductPlan.scss';
</style>
